import { extendTheme } from "@chakra-ui/react";
import { modalAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { defineStyle, defineStyleConfig } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(modalAnatomy.keys);

const config = {
  initialColorMode: "light",
  useSystemColorMode: true,
};

const mode = {
  dark: {
    bg: "black",
    color: "white",
  },
};

const fonts = {
  heading: `'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
  body: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
};

const colors = {
  brand: {
    accent: "#396AFF",
    secondary: "#859BB7",
    text: {
      primary: "#000914",
      secondary: "#666666",
    },
    bg: {
      primary: "#f8f8fa",
    },
  },
};

// const styles = {
//   global: {
//     "html, body": {
//       color: "brand.text.primary",
//     },
//   },
// };

const Button = defineStyleConfig({
  baseStyle: {
    fontWeight: "medium",
  },
  variants: {
    solid: defineStyle({
      bg: "brand.accent",
      color: "#fff",
      _focusVisible: false,
      _hover: {
        bg: "brand.accent",
      },
      _dark: {
        bg: "black",
        color: "white",
        _hover: {
          bg: "gray.700",
        },
      },
    }),
  },
});

const Modal = defineMultiStyleConfig({
  baseStyle: definePartsStyle({
    dialog: {
      p: 4,
      borderRadius: 15,
    },
    _dark: {
      bg: "gray.700",
      color: "white",
    },
  }),
});

const Menu = defineMultiStyleConfig({
  baseStyle: definePartsStyle({
    list: {
      borderRadius: 15,
      p: 2,
    },
    item: {
      borderRadius: "11px",
      py: 2,
      _hover: {
        bg: "gray.100",
        color: "black",
      },
      _dark: {
        color: "white",
        _hover: {
          bg: "gray.900",
          color: "white",
        },
      },
    },
  }),
});

const theme = extendTheme({
  config,
  fonts,
  colors,
  mode,
  components: {
    Button,
    Modal,
    Menu,
  },
});

export { theme };
